import { Grid } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { formatCurrencyInt } from 'shared/utils/numberFormatters';
import { useMemo } from 'react';
import { Table } from 'components/shared/Table';
import { startCase } from 'lodash';
import { calculateMonthlyRentSummary } from '../helpers';

type SummaryTableProps = {
  compGroup: any;
  subjectUnitGroups: any[];
};

const SummaryTable = observer(({ compGroup, subjectUnitGroups }: SummaryTableProps) => {
  const { use, comps } = compGroup;
  const columns = useMemo(() => {
    return [
      {
        field: 'compGroup',
        headerName: startCase(use),
        editable: false,
        flex: 1,
      },
      {
        field: 'min',
        headerName: 'Min',
        editable: false,
      },
      {
        field: 'avg',
        headerName: 'Avg',
        editable: false,
      },
      {
        field: 'max',
        headerName: 'Max',
        editable: false,
      },
    ];
  }, [use]);
  const subjectUnits = subjectUnitGroups.find((group) => group.use === use)?.units || [];
  const rentSummary = calculateMonthlyRentSummary(subjectUnits, comps);

  const rows = [
    {
      id: 0,
      compGroup: 'Subject Units',
      min: formatCurrencyInt(rentSummary.subjectUnits.min),
      avg: formatCurrencyInt(rentSummary.subjectUnits.average),
      max: formatCurrencyInt(rentSummary.subjectUnits.max),
    },
    {
      id: 1,
      compGroup: 'Comps',
      min: formatCurrencyInt(rentSummary.comps.min),
      avg: formatCurrencyInt(rentSummary.comps.average),
      max: formatCurrencyInt(rentSummary.comps.max),
    },
  ];

  return (
    <Grid xs={4} pb={1}>
      <Table rows={rows} columns={columns} />
    </Grid>
  );
});

export { SummaryTable };
